var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"form-control",attrs:{"label":_vm.label,"error-messages":_vm.errorMessages,"value":_vm.inner,"mask":"##h ##m ##s"},on:{"input":_vm.doInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }